import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const TransactionType = (props) => {
  return (
    <FormGroup controlId="policyEndorsementIssued">
      <Col componentClass={ControlLabel} sm={2}>
        Transaction Type
      </Col>
      <Col sm={10}>
            <select
              className="custom-select"
              onChange={props.handleChangeTransactionType}
              value={props.transTypeValue}
            >
            <option value="">Please select</option>
            <option value="newBusiness">New Business</option>
            <option value="extension">Extension</option>
            <option value="endorsement">Endorsement</option>
            <option value="renewal">Renewal</option>
            </select>
      </Col>
    </FormGroup>
  )
}

TransactionType.propTypes = {
  handleChangeTransactionType: PropTypes.func,
  transTypeValue: PropTypes.string
};

export default TransactionType;



// WEBPACK FOOTER //
// ./src/app/components/transactionType/TransactionType.js